export function disableBackForwardCache() {
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      window.location.reload();
    }
  });
  window.addEventListener('unload', () => undefined);
}
